// extracted by mini-css-extract-plugin
export var clickThrough = "_yy-2";
export var fallback = "_yy-5";
export var frame = "_yy-3";
export var frameCell = "_yy-1";
export var overlay = "_yy-4";
export var wrapper = "_yy-0";